import {
  ICartDetailsResponseData,
  ICartListResponseData,
  ICartStatusListResponseData,
  ICartUserInvoiceListResponseListData,
  IHDCartAddressClusterChangeResponse,
  IHDCartAddressClusterChangeResponseData,
  IHDCartAddressDetailResponseData,
  IHDCartAddressListResponseData,
  IHDCartAddressSelectResponseData,
  IHDCartAddressUpdatePutBody,
  IHDCartCheckoutPostBody,
  IHDCartItemsAddPutBody,
  IHDCartItemsListResponseData,
  IHDCartOrderCreationResponseData,
  IHDCartProceedPaymentResponse,
  IHDCouponsListResponseData,
  IHDDeleteCartItemPostBody,
  IWhatsappSendRequestResponseData,
} from "@/api_framework/api_modals/Cart";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import {
  ICreditNoteResponseData,
  IDebitNoteFilter,
  IPaymentDebitNoteData,
  IPaymentWalletDetails,
} from "@/api_framework/api_modals/payment";
import { IInvoiceProps } from "@/app/hooks/api_hooks/Cart/useCartInvoiceListAPI";

export interface ICartState {
  cartStatusList: ICartStatusListResponseData[] | null;
  activeCartId: string;
  cartLevelCouponId: string;
  activeCartDetails: ICartDetailsResponseData | null;
  debitNoteList: IPaymentDebitNoteData[];
  debitNoteFilter: IDebitNoteFilter | null;
  refundRequestFilter: IDebitNoteFilter | null;
  refundRequestList: any;
  inoviceList: ICartUserInvoiceListResponseListData[];
  invoiceListFilter: IInvoiceProps | null;
  isInvoiceLoad: boolean;
  creditNoteList: ICreditNoteResponseData[];
  cartList: ICartListResponseData[];
  walletDetails: IPaymentWalletDetails | null;
  cartListFilter: any;
  unbilledCart: number;
  cartLevelCoupon: any;
  addressList: IHDCartAddressListResponseData[] | null;
  addressSelect: IHDCartAddressSelectResponseData | null;
  addressDetail: IHDCartAddressDetailResponseData | null;
  addressUpdate: IHDCartAddressUpdatePutBody | null;
  cartItemsList: IHDCartItemsListResponseData | null;
  hdCouponsList: IHDCouponsListResponseData[] | null;
  hdDeleteCartItem: IHDDeleteCartItemPostBody | null;
  hdCartItemAdd: IHDCartItemsAddPutBody | null;
  hdCartOrderCreation: IHDCartOrderCreationResponseData | null;
  hdWhatsappSendRequest: IWhatsappSendRequestResponseData | null;
  hdCartCheckout: IHDCartCheckoutPostBody | null;
  hdCartProceedPayment: IHDCartProceedPaymentResponse | null;
  hdAddressClusterChange: IHDCartAddressClusterChangeResponseData | null;
}

export interface ICartInitialState extends IRouteReducerSliceStateInit {
  state: ICartState;
}

const initialState: ICartInitialState = {
  state: {
    cartStatusList: [],
    activeCartId: null,
    activeCartDetails: null,
    cartLevelCouponId: null,
    debitNoteList: [],
    debitNoteFilter: null,
    refundRequestFilter: null,
    refundRequestList: [],
    inoviceList: [],
    invoiceListFilter: null,
    isInvoiceLoad: false,
    creditNoteList: [],
    cartList: [],
    walletDetails: null,
    cartListFilter: null,
    unbilledCart: 0,
    cartLevelCoupon: [],
    addressList: [],
    addressSelect: null,
    addressDetail: null,
    addressUpdate: null,
    cartItemsList: null,
    hdCouponsList: [],
    hdDeleteCartItem: null,
    hdCartItemAdd: null,
    hdCartOrderCreation: null,
    hdWhatsappSendRequest: null,
    hdCartCheckout: null,
    hdCartProceedPayment: null,
    hdAddressClusterChange: null,
  },
};

const cartSlice = createSlice({
  name: "cart_slice",
  initialState: initialState,
  reducers: {
    RESET_INVOICE_CART_SLICE: () => {
      return initialState;
    },
    setCartstatusList: (
      state,
      action: PayloadAction<{
        data: ICartStatusListResponseData[];
      }>,
    ) => {
      state.state.cartStatusList = action.payload.data;
    },
    setActiveCartId: (state, action: PayloadAction<string>) => {
      state.state.activeCartId = action.payload;
    },
    setIsInvoiceLoad: (state, action: PayloadAction<boolean>) => {
      state.state.isInvoiceLoad = action.payload;
    },
    setCartLevelCouponId: (state, action: PayloadAction<string>) => {
      state.state.cartLevelCouponId = action.payload;
    },
    setActiveCartDetails: (state, action: PayloadAction<ICartDetailsResponseData>) => {
      state.state.activeCartDetails = action?.payload;
    },
    setDebitNoteList: (state, action: PayloadAction<IPaymentDebitNoteData[]>) => {
      state.state.debitNoteList = action?.payload;
    },
    setRefundRequestList: (state, action: PayloadAction<any[]>) => {
      state.state.refundRequestList = action?.payload;
    },
    setDebitNoteFilter: (state, action: PayloadAction<IDebitNoteFilter>) => {
      state.state.debitNoteFilter = action?.payload;
    },
    setRefundRequestFilter: (state, action: PayloadAction<IDebitNoteFilter>) => {
      state.state.refundRequestFilter = action?.payload;
    },
    setInvoiceListFilter: (state, action: PayloadAction<IInvoiceProps>) => {
      state.state.invoiceListFilter = action?.payload;
    },
    setInoviceList: (state, action: PayloadAction<ICartUserInvoiceListResponseListData[]>) => {
      state.state.inoviceList = action?.payload;
    },
    setCreditNoteList: (state, action: PayloadAction<ICreditNoteResponseData[]>) => {
      state.state.creditNoteList = action?.payload;
    },
    setCartList: (state, action: PayloadAction<ICartListResponseData[]>) => {
      state.state.cartList = action?.payload;
    },
    setCartLevelCoupon: (state, action: PayloadAction<any[]>) => {
      state.state.cartLevelCoupon = action?.payload;
    },
    setUnbilledCart: (state, action: PayloadAction<number>) => {
      state.state.unbilledCart = action?.payload;
    },
    setWalletDetails: (state, action: PayloadAction<IPaymentWalletDetails>) => {
      state.state.walletDetails = action?.payload;
    },
    setCartListFilter: (state, action: PayloadAction<any>) => {
      state.state.cartListFilter = action?.payload;
    },
    setAddressList: (state, action: PayloadAction<{ data: IHDCartAddressListResponseData[] }>) => {
      state.state.addressList = action?.payload.data;
    },
    setAddressSelect: (state, action: PayloadAction<{ data: IHDCartAddressSelectResponseData }>) => {
      state.state.addressSelect = action?.payload.data;
    },
    setAddressDetail: (state, action: PayloadAction<{ data: IHDCartAddressDetailResponseData }>) => {
      state.state.addressDetail = action?.payload.data;
    },
    setAddressUpdate: (state, action: PayloadAction<{ data: IHDCartAddressUpdatePutBody }>) => {
      state.state.addressUpdate = action?.payload.data;
    },
    setCartItemsList: (state, action: PayloadAction<{ data: IHDCartItemsListResponseData }>) => {
      state.state.cartItemsList = action?.payload.data;
    },
    setHDCouponsList: (state, action: PayloadAction<{ data: IHDCouponsListResponseData[] }>) => {
      state.state.hdCouponsList = action?.payload.data;
    },
    setHDDeleteCartItem: (
      state,
      action: PayloadAction<{
        data: IHDDeleteCartItemPostBody;
      }>,
    ) => {
      state.state.hdDeleteCartItem = action.payload.data;
    },
    setHDCartItemAdd: (state, action: PayloadAction<{ data: IHDCartItemsAddPutBody }>) => {
      state.state.hdCartItemAdd = action?.payload.data;
    },
    setHDCartOrderCreation: (state, action: PayloadAction<{ data: IHDCartOrderCreationResponseData }>) => {
      state.state.hdCartOrderCreation = action?.payload.data;
    },
    setWhatsappSendRequest: (state, action: PayloadAction<{ data: IWhatsappSendRequestResponseData }>) => {
      state.state.hdWhatsappSendRequest = action?.payload.data;
    },
    setHDCartCheckout: (state, action: PayloadAction<{ data: IHDCartCheckoutPostBody }>) => {
      state.state.hdCartCheckout = action?.payload.data;
    },
    setHDCartProceedPayment: (state, action: PayloadAction<{ data: IHDCartProceedPaymentResponse }>) => {
      state.state.hdCartProceedPayment = action?.payload.data;
    },
    setHDAddressClusterChange: (state, action: PayloadAction<{ data: IHDCartAddressClusterChangeResponseData }>) => {
      state.state.hdAddressClusterChange = action?.payload.data;
    },
  },
});

export const {
  setCartstatusList,
  setActiveCartId,
  setActiveCartDetails,
  setCartLevelCouponId,
  setDebitNoteList,
  setInoviceList,
  setRefundRequestList,
  setDebitNoteFilter,
  setIsInvoiceLoad,
  setInvoiceListFilter,
  setRefundRequestFilter,
  setCreditNoteList,
  setCartList,
  setUnbilledCart,
  RESET_INVOICE_CART_SLICE,
  setWalletDetails,
  setCartListFilter,
  setCartLevelCoupon,
  setAddressList,
  setAddressSelect,
  setAddressDetail,
  setAddressUpdate,
  setCartItemsList,
  setHDCouponsList,
  setHDDeleteCartItem,
  setHDCartItemAdd,
  setHDCartOrderCreation,
  setWhatsappSendRequest,
  setHDCartCheckout,
  setHDCartProceedPayment,
  setHDAddressClusterChange,
} = cartSlice.actions;
export default cartSlice.reducer;
